@if (tab_layout) {
  <button class="mb-4" mat-flat-button color="accent" type="button" (click)="add()">
    <mat-icon>add</mat-icon>
    Crear ubicación
  </button>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
      ></mat-paginator>
    </form>

    <div class="bisual-table-container">
      <ng-container *ngTemplateOutlet="locations_table"></ng-container>
    </div>
  </div>
} @else {
  @if (!hide_title) {
    <div class="page-title">
      <h1>Ubicaciones</h1>
      <button mat-flat-button color="accent" (click)="add()">Crear ubicación</button>
    </div>
  }

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <div class="left-filters">
        <mat-paginator
          [length]="length"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="pageIndex"
          (page)="changePage($event)"
        ></mat-paginator>
        @if (can_filter) {
          <mat-form-field appearance="outline" class="bisual-paginator-select">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="relatable_type" (selectionChange)="onRelatableTypeChange($event)">
              <mat-option [value]="'undefined'">Todos</mat-option>
              @for (item of relatable_types_labels | keyvalue; track item.key) {
                <mat-option [value]="item.key">{{ item.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (filterForm.value.relatable_type === LocationRelatableTypeEnum.Company) {
            <app-company-search-dialog
              [have_placeholder]="false"
              [have_mat_icon]="true"
              [show_only_active_company_products]="true"
              [full_width]="false"
              autocomplete_panel_class="location-autocomplete-panel"
              option_class_prefix="option"
              (companySelected)="onCompanySelected($event)"
              (cleared)="onCompanySearchCleared()"
            />
          } @else if (filterForm.value.relatable_type === LocationRelatableTypeEnum.PotentialClient) {
            <mat-form-field appearance="outline">
              <mat-label>Cliente potencial</mat-label>
              <input matInput type="text" [formControl]="potential_client_search" [matAutocomplete]="potentialClientAutocomplete" />
              <mat-autocomplete
                #potentialClientAutocomplete="matAutocomplete"
                class="location-autocomplete-panel"
                [displayWith]="displayPotentialClient.bind(this)"
                (optionSelected)="onPotentialClientSelected($event)"
              >
                @if (potential_client_search_term().length > 0 && potential_client_search_term().length < 3) {
                  <mat-option disabled>Escribe al menos 3 caracteres para buscar.</mat-option>
                } @else if (potential_client_search_loading()) {
                  <mat-option disabled>
                    <mat-spinner diameter="24"></mat-spinner>
                  </mat-option>
                } @else if (potential_client_search_term().length >= 3 && filtered_potential_clients.length === 0) {
                  <mat-option disabled>No se han encontrado coincidencias.</mat-option>
                } @else {
                  @for (potential_client of filtered_potential_clients; track potential_client.id) {
                    <mat-option [value]="potential_client">
                      <span class="option">
                        <span class="option-text">
                          <span class="option-label">{{ potential_client.full_name }}</span>
                          @if (potential_client.company_name) {
                            <span class="option-subtitle">{{ potential_client.company_name }}</span>
                          }
                        </span>
                      </span>
                    </mat-option>
                  }
                }
              </mat-autocomplete>
              <mat-icon matSuffix>business_center</mat-icon>
            </mat-form-field>
          }
        }
      </div>
      @if (can_filter) {
        <div class="right-filters">
          @if (filterForm.value.relatable_type !== 'null') {
            <mat-form-field appearance="outline">
              <mat-label>{{
                user_search_focused() && !(filterForm.value.relatable_type === LocationRelatableTypeEnum.User)
                  ? 'Relacionada con empleado'
                  : 'Empleado'
              }}</mat-label>
              <input
                matInput
                type="text"
                [formControl]="user_search"
                [matAutocomplete]="userAutocomplete"
                (focus)="user_search_focused.set(true)"
                (blur)="user_search_focused.set(false)"
              />
              <mat-autocomplete
                #userAutocomplete="matAutocomplete"
                class="location-autocomplete-panel"
                [displayWith]="displayUser.bind(this)"
                (optionSelected)="onUserSelected($event)"
              >
                @if (user_search_term().length > 0 && user_search_term().length < 3) {
                  <mat-option disabled>Escribe al menos 3 caracteres para buscar.</mat-option>
                } @else if (user_search_loading()) {
                  <mat-option disabled>
                    <mat-spinner diameter="24"></mat-spinner>
                  </mat-option>
                } @else if (user_search_term().length >= 3 && filtered_users.length === 0) {
                  <mat-option disabled>No se han encontrado coincidencias.</mat-option>
                } @else {
                  @for (user of filtered_users; track user.id) {
                    <mat-option [value]="user">
                      <span class="option">
                        <app-user-profile-picture [user]="user" [alt]="user.full_name" [css_class]="'option-logo'" />
                        <span class="option-text">
                          <span class="option-label">{{ user.full_name }}</span>
                        </span>
                      </span>
                    </mat-option>
                  }
                }
              </mat-autocomplete>
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
          }
          <mat-form-field class="search-field">
            <input matInput type="text" formControlName="search" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      }
    </form>

    <div class="bisual-table-container">
      <ng-container *ngTemplateOutlet="locations_table"></ng-container>
    </div>
  </div>
}

<ng-template #locations_table>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let location">{{ location.name }}</td>
    </ng-container>

    @if (
      can_filter &&
      (filterForm.value.relatable_type === 'undefined' ||
        filterForm.value.relatable_type === LocationRelatableTypeEnum.User ||
        filterForm.value.relatable_type === LocationRelatableTypeEnum.Company)
    ) {
      <ng-container matColumnDef="logo_url">
        <th mat-header-cell *matHeaderCellDef>Logo</th>
        <td mat-cell *matCellDef="let location">
          @if (location.logo_url) {
            <img class="table-location-logo" [src]="location.logo_url" alt="Logo" />
          }
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="ips">
      <th mat-header-cell *matHeaderCellDef>IPs</th>
      <td mat-cell *matCellDef="let location">
        @if (location.location_ips?.length) {
          <mat-chip-set>
            @for (ip of location.location_ips; track ip.id) {
              <mat-chip>{{ ip.ip }}</mat-chip>
            }
          </mat-chip-set>
        } @else {
          <span class="text-muted">Sin IPs</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let location">
        @if (!location.is_office) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="edit(location)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="delete(location)">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</ng-template>
